import { render, staticRenderFns } from "./PopoverViewMoreItemComponent.vue?vue&type=template&id=426f38be&scoped=true"
import script from "./PopoverViewMoreItemComponent.vue?vue&type=script&lang=js"
export * from "./PopoverViewMoreItemComponent.vue?vue&type=script&lang=js"
import style0 from "./PopoverViewMoreItemComponent.vue?vue&type=style&index=0&id=426f38be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426f38be",
  null
  
)

export default component.exports